import { getConfigOverride, getMchubEnvironment, MchubEnvironment } from "../session/sessionConstants";

export interface FeatureNames {
  enableApex: boolean;
  enableMds: boolean;
  // McVCN
  enableMcvcn: boolean;
  enableMdsMcvcnCreate: boolean;
  enableVmdbMcvcnCreate: boolean;
  enableExaMcvcnCreate: boolean;
  // Preflight
  useOpcDryRunHeader: boolean;
  enableMdsPreflight: boolean;
  enableVmdbPreflight: boolean;
  enableAdbsPreflight: boolean;
  enableExaInfraPreflight: boolean;
  enableExaVmClusterPreflight: boolean;
  enableExaDbPreflight: boolean;
  // Features
  enableAdbsPE: boolean;
  enableAdbsAJDWorkload: boolean;
  enableAdbsAPEXWorkload: boolean;
  enableAdbsPointInTimeRestore: boolean;
  enableAddVMCapacity: boolean;
  // Debug
  debugInactivity: boolean;
}

export const useFeatures = (): FeatureNames => {
  const env: MchubEnvironment = getMchubEnvironment();

  const features = {
    enableApex: false,
    enableMds: true,
    // McVCN
    enableMcvcn: false,
    enableMdsMcvcnCreate: false,
    enableVmdbMcvcnCreate: false,
    enableExaMcvcnCreate: false,
    // Preflight
    useOpcDryRunHeader: true,
    enableMdsPreflight: true,
    enableVmdbPreflight: true,
    enableAdbsPreflight: true,
    enableExaInfraPreflight: true,
    enableExaVmClusterPreflight: true,
    enableExaDbPreflight: true,
    // Features
    enableAdbsPE: (env === MchubEnvironment.DEV || env === MchubEnvironment.PREPROD),
    enableAdbsAJDWorkload: true,
    enableAdbsAPEXWorkload: true,
    enableAdbsPointInTimeRestore: (env === MchubEnvironment.DEV || env === MchubEnvironment.PREPROD),
    enableAddVMCapacity: (env === MchubEnvironment.DEV || env === MchubEnvironment.PREPROD),
    // Debug
    debugInactivity: false,
  };

  const { features: featureOverrides } = getConfigOverride();

  return featureOverrides ? { ...features, ...featureOverrides } : features;
};
